<oo-loading-container [diameter]="30" [status]="state.status">
  <ng-template>
    <mat-list dense>
      @for (player of state.players; track player.id) {
        <mat-list-item>{{ player.name }}</mat-list-item>
      }
    </mat-list>
    @if (!state.players.length) {
      <div>
        No players set{{ isManageable() ? ', please create one' : '' }}
      </div>
    }
    <div class="oo-actions-section">
      @if (isManageable() && team().isActive) {
        <button (click)="toggleActivation(false)"
                color="warn"
                mat-button>
          Deactivate
        </button>
      }

      @if (isManageable() && !team().isActive) {
        <button (click)="toggleActivation(true)"
                mat-button>
          Activate
        </button>
      }

      @if (isManageable()) {
        <button (click)="openCreatePlayerDialog()"
                color="primary"
                mat-button>
          Add Players
        </button>
      }
    </div>
  </ng-template>
</oo-loading-container>
